import { useEffect } from "react";
import "@/App.css";
import axios from "axios";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Impressum from "@/pages/Impressum";

axios.defaults.withCredentials = true;

function LenisProvider({ children }) {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      if (window.__lenis === lenis) delete window.__lenis;
    };
  }, []);
  return children;
}

function App() {
  return (
    <div className="App bg-yx-bg text-yx-text">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <LenisProvider>
                <Landing />
              </LenisProvider>
            }
          />
          <Route path="/admin" element={<Admin />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
